import { cn } from "@shadcn/lib/utils";
import { Button } from "@shadcn/ui/button";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { HubScannerDrawer } from "./HubScannerDrawer";
import { useI18nContext } from "@i18n/i18n-react";

type HomeScanCTAProps = {
	buttonClassName?: string;
};

export const ScanQR = (props: HomeScanCTAProps) => {
	const { buttonClassName } = props;
	const navigate = useNavigate();
	const i18n = useI18nContext().LL["new-ui"];
	const [isScannerOpen, setIsScannerOpen] = useState(false);

	return (
		<>
			<Button
				className={cn(buttonClassName, "w-full", "font-breit", "text-sm", "font-normal")}
				size="lg"
				onClick={() => setIsScannerOpen(true)}
			>
				{i18n.HOME_SCAN()}
			</Button>
			<HubScannerDrawer
				isOpen={isScannerOpen}
				onClose={() => setIsScannerOpen(false)}
				onHubConnected={(hub) => {
					setIsScannerOpen(false);
					navigate({
						to: "/$hubMetaName/instant-buy",
						params: { hubMetaName: hub.name },
					});
				}}
			/>
		</>
	);
};
